import React from "react"

// Utilities
import { scrollTo } from "../../utilities/scrollTo"
import { handleBannerButton } from "./utilities/formatBannerData"

// Components
import { Link } from "gatsby"

/**
 * @param modifierClass - extra classes for specific style
 * @param columns - whether there are columns in the banner
 * @param imgSrc - the source of the image
 * @param imgWidth - the width of the image
 * @param imgHeight - the height of the image
 * @param title - the title of the banner
 * @param description - the description of the banner
 * @param isHome - boolean that tells whether the banner is on homepage or not
 * @param link - boolean that tells whether there is a link in the banner
 * @param categoryLink - the link of the banner's button
 * @param category - the category of the banner
 * @param rockAndRestore - whether the banner is for rock and restore
 * @param rockYourLife - whether the banner is for rock your life
 * @param isDecember - whether the banner is for december
 * @param isDecember2 - whether the banner is the second style for december
 * */
const BannerItem = ({
  modifierClass,
  columns,
  imgSrc,
  imgWidth,
  imgHeight,
  title,
  description,
  isHome,
  link,
  categoryLink,
  category,
  rockAndRestore,
  rockYourLife,
  isDecember,
  isDecember2,
}) => {
  /*==========================
     HANDLE CATEGORY TEXT FOR SHOP BUTTON
  ===========================*/
  const categoryText = handleBannerButton(category)

  return (
    <>
      {rockAndRestore ? (
        <div className={`banner ${modifierClass ? modifierClass : ""}`}>
          <div className="container">
            <div className="row gutters-20">
              <div className="col-3 txt--center d-none d-md-block">
                <img
                  src="/images/banners/rr-bottle.png"
                  className="rr-bottle"
                  alt="Rock and Restore."
                  width="177"
                  height="350"
                />
              </div>
              <div className={`${columns ? columns : "col-12 col-md-7 col-lg-6"}`}>
                {imgSrc.length ? (
                  <img
                    src={imgSrc}
                    alt={imgSrc}
                    width={imgWidth}
                    height={imgHeight}
                    className="mx--auto d-block d-md-none mb--20"
                    style={{ opacity: imgSrc.length }}
                  />
                ) : (
                  <div className={`banner__dummy-box--${imgHeight}`} />
                )}

                <h2 className="banner__title mb--40 txt--uppercase" dangerouslySetInnerHTML={{ __html: title }} />
                <p className="banner__description">{description}</p>

                <div className="banner__buttons">
                  <Link to={link} className="btn">
                    learn more
                  </Link>
                  {isHome && (
                    <Link to={categoryLink} className="btn">
                      {categoryText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : rockYourLife ? (
        <div className={`banner ${modifierClass ? modifierClass : ""}`}>
          <div className="container">
            <div className="row">
              <div className={`${columns ? columns : "col-12 col-md-7 col-lg-6"}`}>
                {imgSrc.length ? (
                  <img
                    src={imgSrc}
                    alt={imgSrc}
                    width={imgWidth}
                    height={imgHeight}
                    className="mx--auto d-block d-md-none mb--20"
                    style={{ opacity: imgSrc.length }}
                  />
                ) : (
                  <div className={`banner__dummy-box--${imgHeight}`} />
                )}

                <h2 className="banner__title mb--40 txt--uppercase" dangerouslySetInnerHTML={{ __html: title }} />

                <p className="banner__description">{description}</p>

                <div className="banner__buttons">
                  {isHome && (
                    <a href={categoryLink} className="btn" target="_blank" rel="nooperner noreferrer">
                      {categoryText}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : isDecember ? (
        <div className={`banner ${modifierClass ? modifierClass : ""}`}>
          <div className="container">
            <div className="row">
              <div className={`${columns ? columns : "col-12 col-md-7 col-lg-6"}`}>
                {imgSrc.length ? (
                  <img
                    src={imgSrc}
                    alt={imgSrc}
                    width={imgWidth}
                    height={imgHeight}
                    className="mx--auto d-block d-md-none mb--20"
                    style={{ opacity: imgSrc.length }}
                  />
                ) : (
                  <div className={`banner__dummy-box--${imgHeight}`} />
                )}
                <img
                  src={"/images/banners/shipping-flags.png"}
                  alt="Flags."
                  width="414"
                  height="37"
                  className="mx--auto d-block mb--10"
                />
                <p className="txt--uppercase txt--18 txt--xs-14 mb--10">Now shipping in the US, UK and Canada!</p>
                <h2 className="banner__title mb--40 txt--uppercase">Celebration Sale</h2>

                <p className="banner__description">
                  Save{" "}
                  <span className="txt--pink">
                    <strong>10-20%</strong>
                  </span>{" "}
                  on select items in
                  <br /> the store through <strong>December 25th!</strong>
                </p>

                <div className="banner__buttons">
                  {isHome && (
                    <a onClick={scrollTo} href={categoryLink} className="btn">
                      {categoryText}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : isDecember2 ? (
        <div className={`banner ${modifierClass ? modifierClass : ""}`}>
          <div className="container">
            <div className="row">
              <div className={`${columns ? columns : "col-12 col-md-7 col-lg-6"}`}>
                {imgSrc.length ? (
                  <img
                    src={imgSrc}
                    alt={imgSrc}
                    width={imgWidth}
                    height={imgHeight}
                    className="mx--auto d-block d-md-none mb--20"
                    style={{ opacity: imgSrc.length }}
                  />
                ) : (
                  <div className={`banner__dummy-box--${imgHeight}`} />
                )}
                <p className="banner__shipping">
                  Now shipping in the US, UK and Canada!{" "}
                  <img
                    src={"/images/banners/celebration-flags.png"}
                    alt="Flags."
                    width="215"
                    height="23"
                    className="ml--20 ml--md-0"
                  />
                </p>
                <h2 className="banner__title txt--uppercase">
                  Celebration <span className="txt--pink">Sale</span>
                </h2>

                <p className="banner__description">
                  Save{" "}
                  <span className="txt--pink">
                    <strong>10-20%</strong>
                  </span>{" "}
                  on select items in the store through December 25th!
                </p>

                <div className="banner__buttons">
                  {isHome && (
                    <a onClick={scrollTo} href={categoryLink} className="btn">
                      {categoryText}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`banner ${modifierClass ? modifierClass : ""}`}>
          <div className="container">
            <div className="row">
              <div className={`${columns ? columns : "col-12 col-md-7 col-lg-6"}`}>
                {imgSrc.length ? (
                  <img
                    src={imgSrc}
                    alt={imgSrc}
                    width={imgWidth}
                    height={imgHeight}
                    className="mx--auto d-block d-md-none mb--20"
                    style={{ opacity: imgSrc.length }}
                  />
                ) : (
                  <div className={`banner__dummy-box--${imgHeight}`} />
                )}

                <h2 className="banner__title mb--40 txt--uppercase" dangerouslySetInnerHTML={{ __html: title }} />
                <p className="banner__description">{description}</p>

                <div className="banner__buttons">
                  {category !== "apparel" && category !== "merchandise" && category !== "bundles" && (
                    <Link to={link} className="btn">
                      learn more
                    </Link>
                  )}
                  {isHome && (
                    <Link to={categoryLink} className="btn">
                      {categoryText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default BannerItem
